<style lang="scss">
  @import "./style/global.scss";

  h1 {
    font-weight: 300;
  }
</style>

<script>
  import {
    ApolloClient,
    HttpLink,
    InMemoryCache,
    ApolloLink,
  } from "@apollo/client/core";

  import Redeem from "./pages/redeem";

  import { setContext } from "@apollo/client/link/context";
  import { setClient } from "svelte-apollo";
  import { fetch as fetchPolyfill } from "whatwg-fetch";
  import store from "store/dist/store.modern";
  import {
    Router,
    Route,
    createHistory,
    createMemorySource,
  } from "svelte-navigator";

  import PageTemplate from "./templates/page";

  import Checkout from "./pages/checkout";
  import CheckoutSuccess from "./pages/checkout-success";
  import CreateAccount from "./pages/create-account";
  import Account from "./pages/account";
  import Overview from "./pages/overview";
  import Auth from "./pages/auth";
  import Payment from "./pages/payment";
  import Unsubscribe from "./pages/unsubscribe";
  import UnsubscribeSuccess from "./pages/unsubscribe-success";

  import Redirect from "./components/redirect";

  const httpLink = new HttpLink({
    uri: process.env.GRAPHQL_API_URL,
    fetch: window.fetch || fetchPolyfill,
    fetchOptions: {
      mode: "cors",
    },
  });

  const coreClient = new HttpLink({
    uri: process.env.GRAPHQL_CORE_API_URL,
    fetch: window.fetch || fetchPolyfill,
    fetchOptions: {
      mode: "cors",
    },
  });

  const authLink = setContext((_, { headers }) => {
    const token = store.get("access_token");
    let authorizationData = {};

    if (token) {
      authorizationData = {
        Authorization: `Bearer ${token}`,
      };
    }

    return {
      headers: {
        ...headers,
        ...authorizationData,
      },
    };
  });

  const defaultOptions = {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "ignore",
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    },
  };

  const createApolloClient = () =>
    new ApolloClient({
      link: ApolloLink.split(
        (operation) => operation.getContext().clientName === "core",
        authLink.concat(coreClient),
        authLink.concat(httpLink)
      ),
      cache: new InMemoryCache(),
      defaultOptions: defaultOptions,
    });

  const client = createApolloClient();

  setClient(client);

  const sidebarPages = ["/overview", "/account"];
</script>

<main>
  <Router>
    <PageTemplate matchs="{sidebarPages}">
      <Route path="/">
        <Checkout />
      </Route>

      <Route path="/auth">
        <Auth />
      </Route>

      <Route path="/payment">
        <Payment />
      </Route>

      <Route path="/checkout-success">
        <CheckoutSuccess />
      </Route>

      <Route path="/create-account">
        <CreateAccount />
      </Route>

      <Route path="/unsubscribe">
        <Unsubscribe />
      </Route>

      <Route path="/unsubscribe-success">
        <UnsubscribeSuccess />
      </Route>

      <Route path="/overview">
        <Overview />
      </Route>

      <Route path="/account">
        <Account />
      </Route>

      <Route path="/redeem/:id">
        <Redeem />
      </Route>

      <Route path="*">
        <Redirect />
      </Route>
    </PageTemplate>

  </Router>
</main>
